"use strict";
const _ = require('lodash');
const { alcoholTaxCalculator } = require('../article/alcohol-tax-calculator');
function applyPurchaseInformation(purchaseOrderRow) {
    const { article, orderedQuantity, nrOfKolliOrderedButNotDelivered } = purchaseOrderRow;
    if (article) {
        const { purchasePrice, purchaseInformation = '' } = article;
        const purchasePriceExcludingPantAndTax = _.round(purchasePrice - article.recycleAmount - alcoholTaxCalculator(article), 2);
        const kolliAlreayOrderedText = nrOfKolliOrderedButNotDelivered
            ? `${nrOfKolliOrderedButNotDelivered} kollin är redan beställda. `
            : '';
        const articlePurchaseInformation = kolliAlreayOrderedText + purchaseInformation.trim();
        return {
            ...purchaseOrderRow,
            orderedQuantity: orderedQuantity || 1,
            price: article.onCopack ? 0 : purchasePriceExcludingPantAndTax,
            articlePurchaseInformation,
        };
    }
    return purchaseOrderRow;
}
function handlePurchaseOrderRowsChange(purchaseOrderRows, modifiedPurchaseOrderRow) {
    if (modifiedPurchaseOrderRow) {
        const index = _.findIndex(purchaseOrderRows, x => x.id === modifiedPurchaseOrderRow.id);
        if (index === -1) {
            return [...purchaseOrderRows];
        }
        /* eslint-disable no-param-reassign */
        // this might be easy to refactor to a new array, but not sure
        purchaseOrderRows[index] = applyPurchaseInformation(modifiedPurchaseOrderRow);
        /* eslint-enable no-param-reassign */
        return purchaseOrderRows;
    }
    return purchaseOrderRows.map(applyPurchaseInformation);
}
module.exports = { handlePurchaseOrderRowsChange };
